export default __webpack_public_path__ + "static/media/image_call-center.e1b2422d.png";